import { render, staticRenderFns } from "./SimplesNacional.vue?vue&type=template&id=37491c68"
import script from "./SimplesNacional.vue?vue&type=script&lang=js"
export * from "./SimplesNacional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports